// extracted by mini-css-extract-plugin
export default {"title2":"Title2-module__title2___hRy2B"};